export const requiredSiraHeaders = [
  "WFID ID",
  "Measurement Laboratory ID",
  "Order number",
  "Lab",
  "Date",
  "Genus",
  "Species (Genus + Species)",
  "Species Verified By",
  "Remark",
  "d18O_lipidextracted",
  "d18O_std_lipidextracted",
  "Reference (VSMOW…)",
  "d18O_cellulose",
  "d18O_std_cellulose",
  "d18O_nitrated",
  "d18O_std_nitrated",
  "d2H_lipidextracted",
  "d2H_std_lipidextracted",
  "Reference (VSMOW…)",
  "d2H_cellulose",
  "d2H_std_cellulose",
  // "d2H_cellulose_Reference (VSMOW…)",
  "d2H_nitrated",
  "d2H_std_nitrated",
  // "d2H_nitrated_Reference (VSMOW…)",
  "d13C_lipidextracted",
  "d13C_std_lipidextracted",
  "Reference (VPDB...)",
  "d13C_cellulose",
  "d13C_std_cellulose",
  // "d13C_cellulose_Reference (VPDB...)",
  "d13C_nitrated",
  "d13C_std_nitrated",
  // "d13C_nitrated_Reference (VPDB...)",
  "d15N_lipidextracted",
  "d15N_std_lipidextracted",
  "Reference (Air...)",
  "d15N_cellulose",
  "d15N_std_cellulose",
  // "d15N_cellulose_Reference (Air...)",
  "d15Nnitrated",
  "d15N_std_nitrated",
  // "d15Nnitrated_Reference (Air...)",
  "d34S_lipidextracted",
  "d34S_std_lipidextracted",
  "Reference (VCDT...)",
  "d34S_cellulose",
  "d34S_std_cellulose",
  // "d34S_cellulose_Reference (VCDT...)",
  "d34Snitrated",
  "d34S_std_nitrated",
  // "d34Snitrated_Reference (VCDT...)",
];

export const requiredXrfHeaders = [
  "WFID ID",
  "Measurement Laboratory ID",
  "Order number",
  "Lab",
  "Date",
  "Genus",
  "Species (Genus + Species)",
  "Species Verified By",
  "Remark",
  "Tool",
  "Protocol",
  "Measurement unit",
  "Al",
  "Si",
  "P",
  "S",
  "Cl",
  "K",
  "Ca",
  "Mn",
  "Fe",
  "Ni",
  "Cu",
  "Zn",
  "Br",
  "Rb",
  "Sr",
  "Ba",
  "Pb",
  "Ti",
  "V",
  "Cr",
  "Ga",
  "Ge",
  "As",
  "Se",
  "Y",
  "Zr",
  "Nb",
  "Mo",
  "Cd",
  "I",
  "Cs",
  "Bi",
  "Th",
  "U",
];

export const requiredIcpMsHeaders = [
  "WFID ID",
  "Order number",
  "Lab",
  "Measurement Laboratory ID",
  "Date",
  "Genus",
  "Species (Genus + Species)",
  "Species Verified By",
  "Remark",
  "Protocol",
  "Measurement unit",
  "Li_NA",
  "Li_LowerDetection",
  "Be_NA",
  "Be_LowerDetection",
  "Na_NA",
  "Na_LowerDetection",
  "Mg_NA",
  "Mg_LowerDetection",
  "Al_NA",
  "Al_LowerDetection",
  "Si_NA",
  "Si_LowerDetection",
  "P_NA",
  "P_LowerDetection",
  "K_NA",
  "K_LowerDetection",
  "Ca_NA",
  "Ca_LowerLimit",
  "Sc_NA",
  "Sc_LowerLimit",
  "Ti_NA",
  "Ti_LowerLimit",
  "V_NA",
  "V_LowerLimit",
  "Cr_NA",
  "Cr_LowerLimit",
  "Mn_NA",
  "Mn_LowerLimit",
  "Fe_NA",
  "Fe_LowerLimit",
  "Co_NA",
  "Co_LowerLimit",
  "Ni_NA",
  "Ni_LowerLimit",
  "Cu_NA",
  "Cu_LowerLimit",
  "Zn_NA",
  "Zn_LowerLimit",
  "Ga_NA",
  "Ga_LowerLimit",
  "Ge_NA",
  "Ge_LowerLimit",
  "As_NA",
  "As_LowerLimit",
  "Se_NA",
  "Se_LowerLimit",
  "Rb_NA",
  "Rb_LowerLimit",
  "Sr_NA",
  "Sr_LowerLimit",
  "Y_NA",
  "Y_LowerLimit",
  "Zr_NA",
  "Zr_LowerLimit",
  "Nb_NA",
  "Nb_LowerLimit",
  "Mo_NA",
  "Mo_LowerLimit",
  "Cd_NA",
  "Cd_LowerLimit",
  "In_NA",
  "In_LowerLimit",
  "Sn_NA",
  "Sn_LowerLimit",
  "Sb_NA",
  "Sb_LowerLimit",
  "Te_NA",
  "Te_LowerLimit",
  "Cs_NA",
  "Cs_LowerLimit",
  "Ba_NA",
  "Ba_LowerLimit",
  "La_NA",
  "La_LowerLimit",
  "Ce_NA",
  "Ce_LowerLimit",
  "Pr_NA",
  "Pr_LowerLimit",
  "Nd_NA",
  "Nd_LowerLimit",
  "Sm_NA",
  "Sm_LowerLimit",
  "Eu_NA",
  "Eu_LowerLimit",
  "Gd_NA",
  "Gd_LowerLimit",
  "Tb_NA",
  "Tb_LowerLimit",
  "Dy_NA",
  "Dy_LowerLimit",
  "Ho_NA",
  "Ho_LowerLimit",
  "Er_ NA",
  "Er_LowerLimit",
  "Tm_NA",
  "Tm_LowerLimit",
  "Yb_NA",
  "Yb_LowerLimit",
  "Lu_NA",
  "Lu_LowerLimit",
  "Hf_NA",
  "Hf_LowerLimit",
  "Ta_NA",
  "Ta_LowerLimit",
  "W_NA",
  "W_LowerLimit",
  "Re_NA",
  "Re_LowerLimit",
  "Hg_NA",
  "Hg_LowerLimit",
  "Tl_NA",
  "Tl_LowerLImit",
  "Pb_NA",
  "Pb_LowerLimit",
  "Bi_NA",
  "Bi_LowerLimit",
  "Th_NA",
  "Th_LowerLimit",
  "U_NA",
  "U_LowerLimit",
];

export const requiredSiraXRFHeaders = [
  "WFID ID",
  "Order number",
  "Lab",
  "Measurement Laboratory ID",
  "Date",
  "Genus",
  "Species (Genus + Species)",
  "Species Verified By",
  "Remark",
  "d18O_lipidextracted",
  "d18O_std_lipidextracted",
  "Reference (VSMOW…)",
  "d18O_cellulose",
  "d18O_std_cellulose",
  "d18O_nitrated",
  "d18O_std_nitrated",
  "d2H_lipidextracted",
  "d2H_std_lipidextracted",
  "Reference (VSMOW…)",
  "d2H_cellulose",
  "d2H_std_cellulose",
  "d2H_nitrated",
  "d2H_std_nitrated",
  "d13C_lipidextracted",
  "d13C_std_lipidextracted",
  "Reference (VPDB...)",
  "d13C_cellulose",
  "d13C_std_cellulose",
  "d13C_nitrated",
  "d13C_std_nitrated",
  "d15N_lipidextracted",
  "d15N_std_lipidextracted",
  "Reference (Air...)",
  "d15N_cellulose",
  "d15N_std_cellulose",
  "d15Nnitrated",
  "d15N_std_nitrated",
  "d34S_lipidextracted",
  "d34S_std_lipidextracted",
  "Reference (VCDT...)",
  "d34S_cellulose",
  "d34S_std_cellulose",
  "d34Snitrated",
  "d34S_std_nitrated",
  "Al",
  "Si",
  "P",
  "S",
  "Cl",
  "K",
  "Ca",
  "Mn",
  "Fe",
  "Ni",
  "Cu",
  "Zn",
  "Br",
  "Rb",
  "Sr",
  "Ba",
  "Pb",
  "Ti",
  "V",
  "Cr",
  "Ga",
  "Ge",
  "As",
  "Se",
  "Y",
  "Zr",
  "Nb",
  "Mo",
  "Cd",
  "I",
  "Cs",
  "Bi",
  "Th",
  "U",
];

